import 'file-loader?name=vendor/console.js!uglify-loader!console-polyfill'
import 'file-loader?name=vendor/babel-polyfill.js!babel-polyfill/dist/polyfill.min'
import 'file-loader?name=vendor/document-register-element.js!document-register-element/build/document-register-element'
import 'file-loader?name=vendor/picturefill.js!picturefill/dist/picturefill.min'
import 'file-loader?name=vendor/normalize.css!csso-loader!normalize.css/normalize.css'
import $ from 'jquery';
require('../DocumentDefault/AssetsVendor/jquery-ui-widget.js');
require('../DocumentDefault/AssetsVendor/jquery.selectBoxIt.min.js');

// Disabled links
$( 'a.disabled' ).each( function() {
    $( this ).click( function( e ) {
        e.preventDefault();
        e.stopPropagation();
    });
});

// Open external links in new tab
$( 'a' ).each( function() {

  const siteURL = new RegExp( '/' + window.location.host + '/' );
  const currentHref = this.href;

  if ( ! siteURL.test( currentHref ) && currentHref !== undefined && '' !== currentHref ) {
      $( this ).click( function( e ) {
          e.preventDefault();
          e.stopPropagation();
          window.open( currentHref, '_blank' );
      });
  }
});

if ($(".nf-form-cont").length) {
    jQuery(document).on( 'nfFormReady', function( e, layoutView ) {
        let $container = $('.listselect-container select');

        $container.selectBoxIt({
            // options
        });
    });
}


// WEBPACK FOOTER //
// ./Components/DocumentDefault/script.js